export const categories = [
  {
    slug: 'live-casino',
    name: '真人娱乐',
    icon: 'ri-live-line',
    description: '真实荷官在线发牌，沉浸式娱乐体验，多种经典玩法任您选择',
    image: 'https://readdy.ai/api/search-image?query=Luxurious%20casino%20interior%20with%20warm%20golden%20lighting%2C%20elegant%20gaming%20tables%20with%20green%20felt%2C%20crystal%20chandeliers%2C%20sophisticated%20atmosphere%2C%20dark%20wood%20furniture%2C%20warm%20amber%20tones%2C%20editorial%20photography%20style&width=800&height=500&seq=cat-live-casino&orientation=landscape',
    articles: [
      { id: 'lc-1', title: '百家乐高级策略指南：提升您的胜率', excerpt: '深入了解百家乐的高级玩法策略，从基础规则到专业技巧，助您在娱乐中获得更佳体验。', date: '2026-08-10', image: 'https://readdy.ai/api/search-image?query=Elegant%20baccarat%20table%20with%20cards%20and%20chips%20in%20warm%20luxurious%20lighting%2C%20sophisticated%20casino%20atmosphere%2C%20golden%20accents%2C%20dark%20wood%20texture&width=600&height=400&seq=art-lc-1&orientation=landscape' },
      { id: 'lc-2', title: '轮盘玩法全解析：从新手到高手', excerpt: '轮盘作为经典娱乐项目，有着丰富的投注策略。本文为您详解各种轮盘玩法。', date: '2026-08-05', image: 'https://readdy.ai/api/search-image?query=Elegant%20roulette%20wheel%20spinning%20in%20luxurious%20casino%20setting%2C%20warm%20golden%20lighting%2C%20dark%20wood%20table%2C%20sophisticated%20atmosphere&width=600&height=400&seq=art-lc-2&orientation=landscape' },
      { id: 'lc-3', title: '龙虎斗游戏技巧与心得分享', excerpt: '龙虎斗作为快节奏的娱乐项目备受青睐，分享实用技巧帮您获得更好的娱乐体验。', date: '2026-07-28', image: 'https://readdy.ai/api/search-image?query=Dragon%20tiger%20casino%20game%20table%20with%20elegant%20design%2C%20golden%20and%20red%20accents%2C%20warm%20luxurious%20lighting%2C%20sophisticated%20atmosphere&width=600&height=400&seq=art-lc-3&orientation=landscape' },
    ],
  },
  {
    slug: 'slots',
    name: '电子游艺',
    icon: 'ri-gamepad-line',
    description: '海量精品电子游戏，炫酷画面与丰厚奖励，随时随地畅享指尖乐趣',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20slot%20machines%20with%20vibrant%20digital%20displays%2C%20luxurious%20gaming%20floor%2C%20warm%20golden%20accents%2C%20modern%20elegant%20casino%20interior%2C%20soft%20ambient%20lighting&width=800&height=500&seq=cat-slots&orientation=landscape',
    articles: [
      { id: 'sl-1', title: '热门电子游戏推荐：2026年必玩榜单', excerpt: '为您精选2026年度最受欢迎的电子游艺项目，每一款都经过精心评测和玩家推荐。', date: '2026-08-08', image: 'https://readdy.ai/api/search-image?query=Colorful%20digital%20slot%20game%20screens%20with%20vibrant%20graphics%2C%20modern%20gaming%20interface%2C%20warm%20ambient%20lighting%2C%20luxurious%20background&width=600&height=400&seq=art-sl-1&orientation=landscape' },
      { id: 'sl-2', title: '电子游艺投注技巧与资金管理', excerpt: '合理的资金管理是娱乐的基础。本文分享科学的投注技巧，让您玩得更尽兴。', date: '2026-07-30', image: 'https://readdy.ai/api/search-image?query=Modern%20digital%20gaming%20setup%20with%20multiple%20screens%2C%20elegant%20dark%20theme%2C%20golden%20highlights%2C%20sophisticated%20atmosphere&width=600&height=400&seq=art-sl-2&orientation=landscape' },
    ],
  },
  {
    slug: 'sports',
    name: '体育赛事',
    icon: 'ri-football-line',
    description: '全球热门赛事实时追踪，丰富投注玩法，专业数据支持，尽享体育激情',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20sports%20arena%20with%20dramatic%20stadium%20lighting%2C%20athletes%20in%20action%2C%20warm%20golden%20atmosphere%2C%20professional%20sports%20photography%20style%2C%20epic%20scale&width=800&height=500&seq=cat-sports&orientation=landscape',
    articles: [
      { id: 'sp-1', title: '2026赛季五大联赛前瞻分析', excerpt: '新赛季即将开启，为您深度分析五大联赛各队实力变化和夺冠热门预测。', date: '2026-08-06', image: 'https://readdy.ai/api/search-image?query=Professional%20soccer%20stadium%20with%20dramatic%20lighting%2C%20green%20field%2C%20epic%20sports%20atmosphere%2C%20warm%20golden%20hour%20light&width=600&height=400&seq=art-sp-1&orientation=landscape' },
      { id: 'sp-2', title: 'NBA新赛季球队实力排行榜', excerpt: 'NBA新赛季各队阵容大洗牌，深度剖析各队实力变化与季后赛前景。', date: '2026-07-25', image: 'https://readdy.ai/api/search-image?query=Basketball%20court%20with%20dramatic%20arena%20lighting%2C%20warm%20atmosphere%2C%20professional%20sports%20photography%2C%20epic%20composition&width=600&height=400&seq=art-sp-2&orientation=landscape' },
    ],
  },
  {
    slug: 'lottery',
    name: '彩票游戏',
    icon: 'ri-ticket-2-line',
    description: '多种官方彩票玩法，安全可靠，及时开奖，为您带来激动人心的幸运时刻',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20lottery%20balls%20and%20tickets%20on%20luxurious%20dark%20background%2C%20golden%20numbers%2C%20warm%20ambient%20lighting%2C%20sophisticated%20design%2C%20fortune%20theme&width=800&height=500&seq=cat-lottery&orientation=landscape',
    articles: [
      { id: 'lt-1', title: '彩票选号技巧与概率分析', excerpt: '科学的选号方法可以提升中奖概率。本文从数学角度为您分析彩票选号策略。', date: '2026-08-03', image: 'https://readdy.ai/api/search-image?query=Golden%20lottery%20balls%20with%20numbers%20on%20elegant%20dark%20surface%2C%20warm%20lighting%2C%20luxurious%20atmosphere%2C%20fortune%20concept&width=600&height=400&seq=art-lt-1&orientation=landscape' },
    ],
  },
  {
    slug: 'fishing',
    name: '捕鱼游戏',
    icon: 'ri-anchor-line',
    description: '精美海底世界，刺激捕鱼体验，丰富奖励等你来拿，休闲娱乐两不误',
    image: 'https://readdy.ai/api/search-image?query=Vibrant%20underwater%20scene%20with%20colorful%20fish%20and%20treasures%2C%20warm%20golden%20light%20rays%20through%20water%2C%20luxurious%20ocean%20theme%2C%20elegant%20composition&width=800&height=500&seq=cat-fishing&orientation=landscape',
    articles: [
      { id: 'fs-1', title: '捕鱼游戏高分技巧大揭秘', excerpt: '想要在捕鱼游戏中获得高分？本文分享老玩家才知道的实用技巧和策略。', date: '2026-08-01', image: 'https://readdy.ai/api/search-image?query=Colorful%20tropical%20fish%20in%20crystal%20clear%20water%20with%20golden%20sunlight%2C%20luxurious%20underwater%20scene%2C%20elegant%20composition&width=600&height=400&seq=art-fs-1&orientation=landscape' },
    ],
  },
];

export const promotions = [
  {
    id: 'promo-1',
    title: '新会员首存豪礼',
    description: '首次存款即享100%欢迎奖金，最高可获赠8888元礼金',
    tag: '热门',
    image: 'https://readdy.ai/api/search-image?query=Luxurious%20gift%20box%20with%20golden%20ribbon%20on%20elegant%20dark%20background%2C%20warm%20golden%20lighting%2C%20premium%20atmosphere%2C%20celebration%20concept&width=600&height=400&seq=promo-1&orientation=landscape',
    color: 'from-amber-600/90 to-orange-700/90',
  },
  {
    id: 'promo-2',
    title: '每周返水高达1.2%',
    description: '所有游戏均可享受每周返水优惠，最高返水比例达1.2%，实时到账',
    tag: '推荐',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20golden%20coins%20stacked%20on%20dark%20luxurious%20surface%2C%20warm%20ambient%20lighting%2C%20wealth%20concept%2C%20sophisticated%20atmosphere&width=600&height=400&seq=promo-2&orientation=landscape',
    color: 'from-emerald-700/90 to-teal-800/90',
  },
  {
    id: 'promo-3',
    title: 'VIP生日专属礼遇',
    description: 'VIP会员生日当月可享专属礼金、免费旋转等多重惊喜福利',
    tag: '限时',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20birthday%20cake%20with%20golden%20decorations%20on%20dark%20luxurious%20background%2C%20warm%20candlelight%2C%20premium%20celebration%20atmosphere&width=600&height=400&seq=promo-3&orientation=landscape',
    color: 'from-rose-700/90 to-pink-800/90',
  },
];

export const membershipTiers = [
  {
    name: '白银会员',
    icon: 'ri-vip-crown-line',
    color: 'text-secondary-400',
    bg: 'bg-secondary-100',
    border: 'border-secondary-300',
    benefits: ['每日提款额度5万', '专属客服通道', '生日礼金', '每月返水0.5%'],
    threshold: '累计存款达1万元',
  },
  {
    name: '黄金会员',
    icon: 'ri-vip-crown-fill',
    color: 'text-primary-500',
    bg: 'bg-primary-100',
    border: 'border-primary-300',
    benefits: ['每日提款额度10万', '7×24小时VIP客服', '生日豪华礼包', '每月返水0.8%', '专属活动邀请'],
    threshold: '累计存款达10万元',
  },
  {
    name: '钻石会员',
    icon: 'ri-vip-diamond-fill',
    color: 'text-accent-500',
    bg: 'bg-accent-100',
    border: 'border-accent-300',
    benefits: ['每日提款额度50万', '一对一专属管家', '生日奢华礼遇', '每月返水1.2%', '私人定制活动', '全球贵宾厅通行'],
    threshold: '累计存款达50万元',
  },
];

export const articles = [
  {
    id: 'art-1',
    title: '壹号娱乐荣膺2026年度最佳综合娱乐平台',
    excerpt: '在刚刚结束的2026年度国际娱乐产业评选中，壹号娱乐凭借卓越的服务品质和创新的娱乐体验，荣获最佳综合娱乐平台大奖。',
    category: '平台动态',
    date: '2026-08-10',
    image: 'https://readdy.ai/api/search-image?query=Luxurious%20award%20ceremony%20with%20golden%20trophy%20on%20stage%2C%20elegant%20dark%20background%2C%20warm%20spotlight%2C%20premium%20atmosphere%2C%20celebration&width=600&height=400&seq=art-1&orientation=landscape',
    content: '在刚刚结束的2026年度国际娱乐产业评选中，壹号娱乐凭借卓越的服务品质和创新的娱乐体验，从众多参选平台中脱颖而出，荣获"最佳综合娱乐平台"大奖。这一荣誉不仅是对壹号娱乐过去一年来不懈努力的肯定，更是对平台未来发展方向的认可。\n\n壹号娱乐自成立以来，始终坚持以用户为中心的服务理念，不断优化产品体验，丰富娱乐内容。平台现已涵盖真人娱乐、电子游艺、体育赛事、彩票游戏等多个娱乐板块，满足不同用户的多元化需求。\n\n在技术创新方面，壹号娱乐投入大量资源提升平台安全性和稳定性，采用国际领先的加密技术保障用户信息和资金安全。同时，平台积极引入人工智能技术，为用户提供个性化的娱乐推荐服务。在客户服务方面，壹号娱乐建立了7×24小时全天候客服体系，确保每位用户的问题都能得到及时响应和妥善解决。\n\n展望未来，壹号娱乐将继续秉持创新、诚信、专业的核心价值观，不断提升服务品质，拓展娱乐内容，为用户带来更加丰富多彩的娱乐体验。',
  },
  {
    id: 'art-2',
    title: '壹号娱乐全新VIP会员体系升级公告',
    excerpt: '为进一步提升会员服务体验，壹号娱乐对VIP会员体系进行全面升级，新增多项专属权益和尊享服务。',
    category: '平台动态',
    date: '2026-08-05',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20VIP%20lounge%20with%20golden%20accents%2C%20luxurious%20furniture%2C%20warm%20ambient%20lighting%2C%20premium%20atmosphere%2C%20sophisticated%20design&width=600&height=400&seq=art-2&orientation=landscape',
    content: '壹号娱乐近日宣布对VIP会员体系进行全面升级，旨在为忠实用户提供更加优质的尊享服务。新版VIP体系在原有基础上新增了多项专属权益，涵盖更高提款额度、一对一管家服务、全球贵宾厅通行等高端服务。\n\n新版VIP会员体系分为白银、黄金、钻石三个等级，用户根据累计存款金额自动升级。每个等级都享有对应的专属权益，等级越高，权益越丰富。\n\n此次升级重点优化了以下几个方面：提款额度大幅提升，钻石会员日提款额度最高可达50万元；客服体系全面升级，黄金及以上会员可享7×24小时专属服务；新增生日专属礼遇，每位VIP会员在生日当月均可获得平台精心准备的礼包；推出全球贵宾厅通行权益，钻石会员可在合作场所享受贵宾级待遇。\n\n壹号娱乐始终相信，优质的服务是平台发展的根本。未来，我们将持续优化会员体系，为每一位用户创造更多价值。',
  },
  {
    id: 'art-3',
    title: '夏季狂欢节活动即将开启，千万好礼等您来',
    excerpt: '壹号娱乐年度盛事夏季狂欢节将于8月15日正式启动，为期一个月的活动准备了丰厚奖励。',
    category: '活动资讯',
    date: '2026-08-01',
    image: 'https://readdy.ai/api/search-image?query=Vibrant%20summer%20carnival%20theme%20with%20golden%20decorations%2C%20festive%20atmosphere%2C%20warm%20lighting%2C%20luxurious%20celebration%20concept%2C%20elegant%20design&width=600&height=400&seq=art-3&orientation=landscape',
    content: '壹号娱乐年度最受期待的夏季狂欢节即将于8月15日盛大开启！本次狂欢节将持续整整一个月，平台准备了总价值超过千万的丰厚奖励，回馈广大用户的长期支持。\n\n活动期间，用户参与任意游戏即可累积狂欢积分，积分可用于兑换现金奖励、免费旋转、实物礼品等多种好礼。此外，每周还将举办排行榜竞赛，排名前列的用户可获得额外大奖。\n\n值得一提的是，本次狂欢节特别设置了每日签到奖励和邀请好友奖励，让更多用户能够轻松参与到这场娱乐盛宴中来。新注册用户在活动期间还可享受专属新手福利，首存即送高额奖金。\n\n壹号娱乐诚邀您一同参与这场夏季娱乐盛典，千万好礼已准备就绪，期待您的加入！',
  },
  {
    id: 'art-4',
    title: '壹号娱乐安全体系全面解读',
    excerpt: '了解壹号娱乐如何通过多层安全防护体系，保障您的账户安全和资金安全。',
    category: '平台动态',
    date: '2026-07-20',
    image: 'https://readdy.ai/api/search-image?query=Modern%20cybersecurity%20concept%20with%20digital%20shield%20and%20golden%20accents%2C%20warm%20dark%20background%2C%20sophisticated%20tech%20atmosphere%2C%20elegant%20design&width=600&height=400&seq=art-4&orientation=landscape',
    content: '在数字化时代，平台安全是用户最关心的问题之一。壹号娱乐深知安全的重要性，建立了多层次、全方位的安全防护体系，确保每一位用户的账户和资金安全。\n\n第一层：数据加密保护。壹号娱乐采用国际标准的SSL/TLS加密协议，所有用户数据传输均经过高强度加密处理，有效防止数据在传输过程中被截获或篡改。\n\n第二层：账户安全防护。平台支持多重身份验证机制，包括短信验证、邮箱验证和二次密码验证，用户可根据需要灵活配置。同时，系统会实时监测异常登录行为，一旦发现可疑操作立即触发安全预警。\n\n第三层：资金安全保障。壹号娱乐与多家知名金融机构合作，用户资金存放于独立托管账户，与平台运营资金完全隔离。所有资金流转均需经过严格的审核流程，确保资金安全无虞。\n\n第四层：隐私保护机制。平台严格遵守隐私保护法规，用户的个人信息均经过脱敏处理，仅用于必要的服务环节。壹号娱乐承诺不会将用户信息泄露给任何第三方。',
  },
  {
    id: 'art-5',
    title: '手机端体验升级：随时随地畅享娱乐',
    excerpt: '壹号娱乐移动端全新改版，更流畅的操作体验，更精美的界面设计，让您随时随地开启娱乐之旅。',
    category: '产品更新',
    date: '2026-07-15',
    image: 'https://readdy.ai/api/search-image?query=Modern%20smartphone%20displaying%20luxurious%20gaming%20interface%20with%20golden%20accents%2C%20elegant%20dark%20background%2C%20warm%20ambient%20lighting%2C%20premium%20tech%20aesthetic&width=600&height=400&seq=art-5&orientation=landscape',
    content: '壹号娱乐移动端近日完成全新改版升级，以更出色的用户体验和更精美的视觉设计，为用户带来随时随地畅享娱乐的极致体验。\n\n本次移动端改版重点优化了以下几个方面：界面设计全面焕新，采用国际流行的简约设计风格，配合金色主题色调，营造高端大气的视觉感受；操作流畅度大幅提升，页面加载速度提升50%以上，游戏切换更加顺滑；新增智能推荐功能，基于用户偏好和行为数据，精准推荐您可能感兴趣的娱乐内容。\n\n此外，移动端还新增了消息推送功能，让您不错过任何重要活动和优惠信息。同时，适配了更多设备型号，无论是手机还是平板，都能获得一致出色的使用体验。\n\n壹号娱乐始终致力于为用户提供极致的娱乐体验，未来我们将持续优化移动端产品，让每一次互动都成为享受。',
  },
  {
    id: 'art-6',
    title: '壹号娱乐社会责任与公益行动年度报告',
    excerpt: '壹号娱乐积极践行企业社会责任，2026年度在多个公益领域持续投入，回馈社会。',
    category: '社会责任',
    date: '2026-07-08',
    image: 'https://readdy.ai/api/search-image?query=Warm%20charity%20and%20community%20support%20concept%20with%20golden%20accents%2C%20elegant%20atmosphere%2C%20hopeful%20theme%2C%20sophisticated%20photography%20style&width=600&height=400&seq=art-6&orientation=landscape',
    content: '壹号娱乐始终坚信，企业的价值不仅体现在商业成就上，更体现在对社会责任的担当。2026年度，壹号娱乐在多个公益领域持续投入，以实际行动回馈社会。\n\n在教育支持方面，壹号娱乐设立了专项助学金，资助了200名来自困难家庭的学生完成学业。同时，平台还在偏远地区捐建了5所希望图书室，为当地儿童提供丰富的阅读资源。\n\n在环保领域，壹号娱乐积极参与绿色公益行动，组织员工参与植树造林活动，全年累计植树超过5000棵。平台还推行绿色办公理念，减少碳排放，践行可持续发展。\n\n在社区服务方面，壹号娱乐定期组织志愿者团队走进社区，开展关爱老人、帮扶残障人士等公益活动。2026年累计志愿服务时长超过10000小时。\n\n壹号娱乐将继续秉持取之于社会、回馈于社会的理念，持续加大公益投入力度，为建设更美好的社会贡献力量。',
  },
];

export const faqs = [
  {
    question: '如何注册壹号娱乐会员？',
    answer: '点击网站右上角的"注册"按钮，填写手机号码、设置密码并完成短信验证，即可快速注册成为壹号娱乐会员。整个注册过程仅需1分钟。',
  },
  {
    question: '壹号娱乐支持哪些存款方式？',
    answer: '壹号娱乐支持多种便捷的存款方式，包括银行卡转账、微信支付、支付宝、USDT数字货币等。所有存款均实时到账，无需等待。',
  },
  {
    question: '提款需要多长时间到账？',
    answer: '壹号娱乐承诺极速提款服务。一般情况下，提款申请提交后10分钟内即可到账。大额提款可能需要额外的安全审核，但最长不超过2小时。',
  },
  {
    question: '如何成为VIP会员？',
    answer: 'VIP会员采用自动升级制度。当您的累计存款金额达到相应标准（白银1万元、黄金10万元、钻石50万元），系统将自动为您升级会员等级，并解锁对应的专属权益。',
  },
  {
    question: '壹号娱乐平台安全吗？',
    answer: '壹号娱乐采用国际领先的安全技术，包括SSL加密传输、多重身份验证、资金独立托管等多层安全防护措施，全方位保障您的账户和资金安全。平台持有正规运营资质，值得信赖。',
  },
  {
    question: '手机可以访问壹号娱乐吗？',
    answer: '当然可以！壹号娱乐拥有专业的移动端适配版本，支持iOS和Android系统。您可以通过手机浏览器直接访问，获得与电脑端一致的高品质娱乐体验。',
  },
  {
    question: '忘记密码怎么办？',
    answer: '点击登录页面的"忘记密码"链接，输入注册手机号码，接收短信验证码后即可重新设置密码。整个过程简单快捷，1分钟内即可完成。',
  },
  {
    question: '壹号娱乐有客服吗？如何联系？',
    answer: '壹号娱乐提供7×24小时全天候在线客服服务。您可以通过网站的在线客服入口、官方客服电话或发送邮件至客服邮箱与我们取得联系，我们的专业团队将第一时间为您解答问题。',
  },
];

export const aboutInfo = {
  brandName: '壹号娱乐',
  founded: '2018年',
  location: '亚洲',
  mission: '以用户为中心，提供安全、公平、优质的多元化娱乐体验，让每一位用户都能在这里找到属于自己的快乐。',
  vision: '成为亚洲最受信赖的综合娱乐平台，以卓越的服务品质引领行业发展。',
  values: [
    { title: '诚信为本', description: '坚持公平公正原则，以诚信赢得用户信赖，建立长久稳固的合作关系。' },
    { title: '用户至上', description: '始终将用户体验放在首位，持续优化服务品质，满足用户多样化需求。' },
    { title: '创新驱动', description: '拥抱技术创新，不断迭代产品功能，为用户带来前沿的娱乐体验。' },
    { title: '安全可靠', description: '采用国际领先的安全技术，构建多层防护体系，全方位保障用户权益。' },
    { title: '责任担当', description: '积极履行企业社会责任，推动行业健康发展，回馈社会大众。' },
  ],
  stats: [
    { value: '500万+', label: '注册用户' },
    { value: '1000+', label: '游戏项目' },
    { value: '99.9%', label: '用户满意度' },
    { value: '7×24h', label: '客服在线' },
  ],
  reputation: [
    { title: '国际娱乐产业协会认证', description: '通过国际娱乐产业协会（IEGA）严格审核，获得正规运营资质认证。', icon: 'ri-verified-badge-line' },
    { title: '信息安全等级保护', description: '通过国家信息安全等级保护三级认证，用户数据安全有保障。', icon: 'ri-shield-check-line' },
    { title: '公平游戏认证', description: '所有游戏均通过第三方独立机构公平性检测，确保游戏结果的随机性和公正性。', icon: 'ri-scales-line' },
    { title: '最佳综合娱乐平台', description: '2026年度荣获国际娱乐产业评选"最佳综合娱乐平台"大奖。', icon: 'ri-trophy-line' },
  ],
  contact: {
    phone: '400-888-9999',
    email: 'service@yihaoentertainment.com',
    address: '亚洲运营中心',
    wechat: 'yihao_yule',
  },
};